/**
 * Onay / yasal metin modülü.
 *
 * Bu özellik bir sayfaya bağlı değil — uygulama açılışında çalışır, bir view'ı
 * yoktur. Kabuk bunu destekliyor: `view` alanı yoksa modül açılışta bir kez
 * başlatılır.
 *
 * BUGÜN KAPALI. `documents.ts` içindeki ACTIVE_REGION `null` olduğu için hiçbir
 * şey render edilmez. KVKK bilinçli olarak kaldırıldı; bu modül altyapıyı hazır
 * tutuyor, açma kararı senin.
 *
 * AÇMAK İÇİN: documents.ts → ACTIVE_REGION = 'tr' (veya 'eu').
 * METNİ DEĞİŞTİRMEK İÇİN: documents.ts → ilgili bölgenin body'si + version++.
 * YENİ ÜLKE İÇİN: documents.ts → DOCUMENTS'a yeni bölge. Başka dosyaya dokunma.
 */

import { defineFeature } from '../../shell/feature.ts';
import { ACTIVE_REGION } from './documents.ts';
import { show, teardown } from './banner.ts';
import { clearConsent, readConsent } from './store.ts';

export default defineFeature({
  id: 'consent',
  label: 'Onay ve yasal metinler',

  // Sayfası yok: açılışta çalışır, kendi DOM'unu kendi yaratır
  view: null,

  boot: () => {
    if (!ACTIVE_REGION) return;   // kapalı — hiçbir şey yapma
    show(ACTIVE_REGION);
  },

  unmount: () => teardown(),

  /**
   * Ayarlar ekranı bu ikisini çağırıyor olabilir; eski koddaki kvkkReset'in
   * yerini alır. Onay silinince banner yeniden görünür.
   */
  legacyGlobals: {
    consentReset: () => {
      clearConsent();
      if (ACTIVE_REGION) show(ACTIVE_REGION);
    },
    consentStatus: () => readConsent(),
  },

  emits: ['consent.granted', 'consent.declined'],
});
